<template>
  <!--Site Footer Here-->
  <footer id="site-footer" class="bg-custom-secondary padding_top">
    <div class="container">
      <div class="row">
        <div class="col-lg-3 col-md-6 col-sm-6">
          <div class="footer_panel padding_bottom_half bottom20">
            <a href="/" class="footer_logo bottom25"
              ><img src="/images/footer-logo.png" alt="logo"
            /></a>
          </div>
        </div>
        <div class="col-lg-3 col-md-6 col-sm-6">
          <div class="footer_panel padding_bottom_half bottom20">
            <h3 class="whitecolor bottom25">Kontak Kami</h3>
            <p class="whitecolor bottom25">
              {{ listInformation.address }}
            </p>
            <div class="d-table w-100 address-item whitecolor bottom25">
              <span class="d-table-cell align-middle"
                ><i class="fas fa-mobile-alt"></i
              ></span>
              <p class="d-table-cell align-middle bottom0">
                {{ listInformation.phone }}
                <a class="d-block" href="mailto:web@support.com"
                  >{{ listInformation.email }}</a
                >
              </p>
            </div>
          </div>
        </div>
        <div class="col-lg-3 col-md-6 col-sm-6">
          <!-- <div class="footer_panel padding_bottom_half bottom20 pl-0 pl-lg-5">
                        <h3 class="whitecolor bottom25">Our Services</h3>
                        <ul class="links">
                            <li><a href="index-logistic.html">Home</a></li>
                            <li><a href="logistic/about.html">About Us</a></li>
                            <li><a href="logistic/news-1.html">Latest News</a></li>
                            <li><a href="logistic/pricing.html">Business Planning</a></li>
                            <li><a href="logistic/contact.html">Contact Us</a></li>
                            <li><a href="logistic/faq.html">Faq's</a></li>
                        </ul>
                    </div> -->
        </div>
        <div class="col-lg-3 col-md-6 col-sm-6">
          <div class="footer_panel padding_bottom_half bottom20">
            <!-- <h4 class="whitecolor bottom25">Business hours</h4> -->
            <p class="whitecolor bottom25">SOSIAL MEDIA KAMI</p>

            <ul class="social-icons white wow fadeInUp" data-wow-delay="300ms">
              <li v-for="(item, index) in listData" :key="index">
                <a :href="item.url" class=""><i :class="item.icon"></i> </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <div style="background-color: #fff; padding: 0.5px"></div>
        </div>
      </div>
      <div class="row">
        <div class="col-12 text-end">
          <p class="whitecolor bottom25 text-end p-3" style="float: right">
            2024© Pemerintah Provinsi DKI Jakarta
          </p>
        </div>
      </div>
    </div>
  </footer>
</template>

<script lang="ts">
import { defineComponent, onMounted, ref } from "vue";
import { useCmsStores } from "@/store/cms";

export default defineComponent({
  props: {
    listData: {
      type: Array,
      default: () => [],
      required: true,
    },
  },
  name: "Footer",
  setup(props) {
    const cmsStore =  useCmsStores();

  
    onMounted(async () => {
      await getInformation();
    });

    const listInformation = ref([]);
    const getInformation = async () => {
      await cmsStore.getContactInformation().then((res) => {
        listInformation.value = res.data.data;
      }).catch((err) => {
        console.log(err);
      });
    }

    return {
      listInformation,
    };
  },
});
</script>
